// Адреса сторінки з української назви.
//
// Раніше slug робився через /[^\w\s-]/g, а \w у JS — це лише латиниця,
// тому «Підлітки» перетворювалось на порожній рядок і програма не
// створювалась зовсім. Тут кирилиця транслітерується.
const TRANSLIT = {
  а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g', д: 'd', е: 'e', є: 'ie', ж: 'zh',
  з: 'z', и: 'y', і: 'i', ї: 'i', й: 'i', к: 'k', л: 'l', м: 'm', н: 'n',
  о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts',
  ч: 'ch', ш: 'sh', щ: 'shch', ь: '', ю: 'iu', я: 'ia',
  // російські літери, яких немає в українській абетці
  ё: 'e', ъ: '', ы: 'y', э: 'e',
};

export function slugify(value) {
  return String(value ?? '')
    .toLowerCase()
    .split('')
    .map((char) => (char in TRANSLIT ? TRANSLIT[char] : char))
    .join('')
    .replace(/['’`]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

export const buildProgramId = (slug) => (slug ? `program-page-${slug}` : '');

export const buildProgramPagePath = (slug) => (slug ? `/programs/${slug}` : '');
